import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
const MIN_VIEWERS = 34;
const MAX_VIEWERS = 71;
export function LiveViewersBadge() {
  const [viewers, setViewers] = useState(47);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const id = window.setInterval(() => {
      setViewers(current => {
        const drift = Math.round((Math.random() - 0.45) * 7);
        const next = current + drift;
        if (next < MIN_VIEWERS) return MIN_VIEWERS + Math.round(Math.random() * 3);
        if (next > MAX_VIEWERS) return MAX_VIEWERS - Math.round(Math.random() * 3);
        return next;
      });
    }, 4500);
    return () => window.clearInterval(id);
  }, []);
  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 180);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div role="status" aria-live="off" className={`ease-luxe fixed right-3 top-9 z-40 flex items-center gap-2 rounded-full border border-gold-400/35 bg-ink-950/90 px-3 py-1.5 shadow-[0_14px_30px_-12px_rgba(0,0,0,0.9)] backdrop-blur-sm transition-[opacity,transform] duration-500 sm:right-5 sm:top-12 sm:translate-y-0 sm:px-3.5 sm:py-2 sm:opacity-100 ${isScrolled ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0'}`} data-id="element-115" data-mp="1skm39wbu0oc1">
      <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-116" data-mp="mcta7e2yc4g1">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#4ade80] opacity-70 sm:animate-ping" data-id="element-117" data-mp="r52xsnglgsf5" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-[#22c55e]" data-id="element-118" data-mp="cgg9hw8zoqbs" />
      </span>
      <Eye className="hidden h-3.5 w-3.5 text-gold-300 sm:block" strokeWidth={1.8} aria-hidden="true" data-id="element-119" data-mp="hdykds6khfmf" />
      <span className="font-mono text-[10px] leading-none text-[#d8d4cc] sm:text-[11px]" data-id="element-120" data-mp="3g1jijl2yn1y">
        <strong className="font-bold text-gold-200" data-id="element-121" data-mp="7gtsrctycry8">{viewers}</strong> viendo ahora
      </span>
    </div>;
}